module.exports = __webpack_public_path__ + "img/amex.4bdb2b86.svg";